import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Do any of the following apply to you?',
    field: 'utiApplyToYou',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'applyTestStrip',
          value: 'I tested positive for a UTI using a test strip'
        },
        { key: 'applyPregnant', value: "I'm pregnant" },
        {
          key: 'applyPotentialSTI',
          value: 'I am concerned about potential STIs'
        },
        {
          key: 'applyNone',
          value: 'None of these apply to me',
          uncheckOthers: true
        }
      ]
    }
  },

  {
    label: 'When was your last UTI?',
    field: 'utiLastUTI',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'utiFourWeeks', value: 'UTI in past 4 weeks' },
        { key: 'utiTwoinSixMonth', value: '2 UTIs in past 6 months' },
        { key: 'utiThreeInYear', value: '3 UTIs in past year' },
        {
          key: 'utiNone',
          value: 'None of these apply to me',
          uncheckOthers: true
        }
      ]
    }
  },

  {
    label: 'Are you experiencing any of the following symptoms?',
    field: 'utiExperiecSymptomsFirst',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'symptomsNeedingToPee', value: 'Constantly needing to pee' },
        { key: 'symptomsBurningWhilePee', value: 'Burning while peeing' },
        { key: 'symptomsPeeingFrequently', value: 'Peeing more frequently' },
        { key: 'symptomsBloodUrine', value: 'Blood in urine' },
        { key: 'symptomsPelvic', value: 'Pelvic pain' },
        {
          key: 'symptomsNone',
          value: 'None of these apply to me',
          uncheckOthers: true
        }
      ]
    }
  },

  {
    label: 'Are you experiencing any of the following symptoms?',
    field: 'utiExperiecSymptomsSecond',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'symptomsSecFeverOrChills', value: 'Fever or chills' },
        { key: 'symptomsSecVaginalDischarge', value: 'Vaginal discharge' },
        { key: 'symptomsSecItching', value: 'Vaginal itching' },
        { key: 'symptomsSecPainfulSex', value: 'Painful sex' },
        {
          key: 'symptomsSecLowBackPain',
          value: 'Low back pain or pain on your side'
        },
        { key: 'symptomsSecNauseaOrVomiting', value: 'Nausea or vomiting' },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'symptomsSecOther',
            placeholder: 'Please specify'
          }
        },
        { key: 'symptomsSecNone', value: 'None', uncheckOthers: true }
      ]
    }
  },

  {
    label: 'Are you allergic to any of the listed medications?',
    field: 'utiAllergicMedications',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'allergicNitrofuratoin', value: 'Nitrofurantoin (MacroBID)' },
        {
          key: 'allergicTrimethoprim',
          value: 'Trimethoprim and sulfamethoxazole'
        },
        { key: 'allergicFosfomycin', value: 'Fosfomycin (Monurol)' },
        { key: 'allergicPenicillin', value: 'Penicillin' },
        { key: 'allergicSulfaDrugs', value: 'Sulfa drugs' },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'allergicOther',
            placeholder: 'Please specify'
          }
        },
        { key: 'allergicNone', value: 'None of the above', uncheckOthers: true }
      ]
    }
  },

  {
    field: 'utiEduacationalSlide',
    type: 'info',
    educationalSlide:
      "We know UTIs suck, We're here to help & get you sorted out.\n\n A member of our Jill Health medical team will reach out to you based on your responses.",
    label: '',
    answer: {}
  }
];
export default questionsModels;
